module.exports = __webpack_public_path__ + "img/Card_password.c436b234.png";